module.exports = __webpack_public_path__ + "static/media/cookie_crumbs.11f7d33b.svg";